const e = {
  name: "CheckmarkSquareFilled",
  dimensions: { width: 20, height: 20 },
  content: `
    <svg>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M0 3C0 1.34315 1.34315 0 3 0H17C18.6569 0 20 1.34315 20 3V17C20 18.6569 18.6569 20 17 20H3C1.34315 20 0 18.6569 0 17V3ZM15.7071 6.29289C16.0976 6.68342 16.0976 7.31658 15.7071 7.70711L9.70711 13.7071C9.3654 14.0488 8.83792 14.0915 8.44977 13.8352C8.39432 13.7986 8.34112 13.7553 8.29231 13.7065L5.29289 10.7071C4.90237 10.3166 4.90237 9.68342 5.29289 9.29289C5.68342 8.90237 6.31658 8.90237 6.70711 9.29289L9 11.5858L14.2929 6.29289C14.6834 5.90237 15.3166 5.90237 15.7071 6.29289Z" fill="currentColor"/>
    </svg>
  `
};
export {
  e as CheckmarkSquareFilled
};
